import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import InquiryForm from "@/components/InquiryForm";
import { CONTACT } from "@/data/content";

const EASE = [0.76, 0, 0.24, 1];

const LeadForm = () => {
  return (
    <section id="plan" className="py-24 md:py-40 bg-[#EFEADF] border-t border-border" data-testid="lead-form-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="uppercase text-xs tracking-[0.25em] font-semibold text-primary mb-6"
            data-testid="lead-form-overline"
          >
            Start here
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
            className="font-heading font-light tracking-tight text-foreground text-4xl sm:text-5xl lg:text-6xl leading-[1.02]"
            data-testid="lead-form-heading"
          >
            Tell us when.<br />We'll handle <em className="text-primary">the rest.</em>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.2 }}
            className="mt-8 text-base md:text-lg font-light text-foreground/75 leading-relaxed max-w-md"
            data-testid="lead-form-copy"
          >
            Group batches leave every Sunday from Bagdogra. Fill this in and
            a TrekPanda travel expert calls you within 24 hours with dates,
            exact pricing and answers about permits, flights and fitness. No
            spam, no obligation.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.3 }}
            className="mt-10 space-y-4"
            data-testid="lead-form-contacts"
          >
            <a
              href={CONTACT.phoneHref}
              className="flex items-center gap-3 text-sm text-foreground/80 hover:text-primary transition-colors duration-300"
              data-testid="lead-form-phone-link"
            >
              <Phone className="w-4 h-4 text-primary" /> {CONTACT.phoneDisplay}
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              className="flex items-center gap-3 text-sm text-foreground/80 hover:text-primary transition-colors duration-300"
              data-testid="lead-form-email-link"
            >
              <Mail className="w-4 h-4 text-primary" /> {CONTACT.email}
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE, delay: 0.15 }}
          className="lg:col-span-7 bg-card border border-border p-8 md:p-12"
          data-testid="lead-form"
        >
          <InquiryForm />
        </motion.div>
      </div>
    </section>
  );
};

export default LeadForm;
